import React from 'react'
import { compose } from 'react-apollo'
import { Form, Modal, Row, Col, Input, Button, Select } from 'antd'
import creditcardBrands from './creditcard_brands.png'
const OmiseModal = ({
  registration,
  amount,
  visible,
  loading,
  onCheckout,
  onClose,
  form
}) => {
  const { getFieldDecorator } = form
  // TODO: move omise logic near to project root (for easier config import too)
  const handleOnSubmit = e => {
    e.preventDefault()
    form.validateFields((err, formData) => {
      // form.validateFields((err, formData) => {
      if (!err) {
        onCheckout(formData)
      }
    })
  }

  return (
    <Modal visible={visible} footer={null} width={400} onCancel={onClose}>
      <Form onSubmit={handleOnSubmit} layout="vertical">
        <Form.Item label="Name on card">
          {getFieldDecorator('name')(<Input />)}
        </Form.Item>
        <Form.Item label="Card number">
          {getFieldDecorator('number')(<Input />)}
        </Form.Item>
        <Row gutter={16}>
          <Col span={7}>
            <Form.Item label="Expiration date" /* wrapperCol={{ span: 4 }} */>
              {getFieldDecorator('expiration_month')(
                <Select>
                  {[...Array(12)].map((_, i) => {
                    const pad = '00'
                    const month = i + 1
                    const MM =
                      pad.substr(0, pad.length - `${month}`.length) + month
                    return (
                      <Select.Option key={MM} value={MM}>{MM}</Select.Option>
                    )
                  })}
                </Select>
              )}
            </Form.Item>
          </Col>
          <Col span={1}>
            <Form.Item label="&nbsp;">
              /
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item label="&nbsp;" /* wrapperCol={{ span: 4 }} */>
              {getFieldDecorator('expiration_year')(
                <Select>
                  {[...Array(20)].map((_, i) => (
                    <Select.Option key={`${2017 + i}`} value={`${2017 + i}`}>
                      {2017 + i}
                    </Select.Option>
                  ))}
                </Select>
              )}
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item label="Security Code" /* wrapperCol={{ span: 4 }} */>
              {getFieldDecorator('security_code')(
                <Input type="password" placeholder="CVC" />
              )}
            </Form.Item>
          </Col>
        </Row>
        <Row align="bottom">
          <Col span={12}>
            <Button htmlType="submit" icon="lock" loading={loading}>
              Pay {amount} THB
            </Button>
          </Col>
          <Col span={12}>
            <img src={creditcardBrands} alt="" />
          </Col>
        </Row>
      </Form>
    </Modal>
  )
}

export default compose(Form.create())(OmiseModal)



// WEBPACK FOOTER //
// ./src/App/components/OmiseModal.js